import * as React from 'react'
import PropTypes from 'prop-types'
import ScrollMagic from 'ScrollMagic'
import './HemicycleFocus.css'

class ScrollBloc extends React.Component {
  constructor (props) {
    super(props)

    this.scrollController = null
  }

  componentDidMount () {
    this.scrollController = new ScrollMagic.Controller()
    this.initScroller()
  }

  initScroller () {
    const scene = new ScrollMagic.Scene({
      triggerElement: this.node,
      triggerHook: 0.5,
      reverse: true
    })
    scene.on('start', event => {
      console.log('Start ' + event.scrollDirection)
      this.props.callback(event.scrollDirection === 'FORWARD' ? 1 : -1)
    })
    // scene.addIndicators()
    this.scrollController.addScene(scene)
  }

  render () {
    return (
      <div
        className='ui text container scrollbloc-container'
        ref={node => {
          this.node = node
        }}
      >
        {this.props.children}
      </div>
    )
  }
}

ScrollBloc.propTypes = {
  children: PropTypes.node,
  callback: PropTypes.func
}

export default ScrollBloc



// WEBPACK FOOTER //
// ./src/components/main/ScrollBloc.js